import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@mui/material';

/**
 * ModalWrapper centralizes Dialog/Paper sizing and scroll behavior.
 * children should provide the inner layout (no absolute positioning required).
 */
export default function ModalWrapper({ open, onClose, children, smWidth = 580, ariaLabel, ariaDesc }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={ariaLabel}
      aria-describedby={ariaDesc}
      scroll="body"
      PaperProps={{
        sx: {
          width: { xs: '90vw', sm: smWidth },
          maxWidth: '90vw',
          p: 0,
          maxHeight: 'calc(100vh - 48px)'
        }
      }}
    >
      <DialogContent sx={{ width: '100%', overflow: 'visible', p: 0, backgroundColor: 'transparent' }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

ModalWrapper.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  smWidth: PropTypes.number,
  ariaLabel: PropTypes.string,
  ariaDesc: PropTypes.string,
};
